import React from 'react'
import PropTypes from 'prop-types'
import pure from 'recompose/pure'
// import ClassNames from 'classnames'
import FormGroup from '@/ui/Form/FormGroup'
import Label from '@/ui/Input/Label'

const SelectField = ({
  className,
  labelText,
  theme,
  prefix,
  // selected, <- not needed as value will be forwared trough ...rest
  items,
  onChange,
  ...rest
}) => {
  const itemsArr = Array.from(Array(items).keys()).map(i => i + 1)
  return (
    <FormGroup>
      <If condition={labelText}>
        <Label key="label" htmlFor={rest.id}>
          {labelText}
        </Label>
      </If>
      <select {...rest} onChange={e => onChange(e, e.target.value)}>
        <For each="item" index="indx" of={itemsArr}>
          <option key={indx} value={indx}>{`${prefix} ${item}`}</option>
        </For>
      </select>
    </FormGroup>
  )
}

SelectField.propTypes = {
  className: PropTypes.string,
  labelText: PropTypes.string,
  prefix: PropTypes.string,
  // selected: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
}

export default pure(SelectField)



// WEBPACK FOOTER //
// ./ui/Blocks/SelectField.js